import { $api } from './interceptor';
import { Paginated } from 'types/paginated';
import { AxiosError } from 'axios';
import { toast } from 'App';
import { tokensStore } from 'views/store/useTokensStore';
import { TTokenItem } from 'views/types/token';
import { TTotalAppVolumeResponse } from 'views/types/volume';

const TokenService = () => {
  const getTokenByPurchase = async ({
    page = 0,
    pageSize = 10,
    searchValue,
    sortingValue,
  }: {
    page?: number;
    pageSize?: number;
    searchValue?: string;
    sortingValue: string;
  }): Promise<Paginated<TTokenItem>> => {
    let search = searchValue;

    try {
      const { data } = await $api.get<Paginated<TTokenItem>>('api/admins/tokens-swap-count', {
        params: {
          search,
          page: page + 1,
          limit: pageSize,
          sortBy: sortingValue,
        },
      });

      tokensStore.setState({
        tokens: data.data,
        totalPages: data.meta.totalPages,
        totalItems: data.meta.totalItems,
      });
      if (!search) {
        tokensStore.setState({
          totalTokens: data.meta.totalItems,
        });
      }
      return data;
    } catch (e) {
      console.log(e);
      if (e instanceof AxiosError) {
        toast({
          title: 'Error',
          description: e.response?.data.message,
          status: 'error',
          position: 'top-right',
        });
      } else {
        toast({
          title: 'Error fetching user list',
          status: 'error',
          isClosable: true,
          position: 'top-right',
        });
      }
      throw e;
    }
  };

  const getTokenAppVolume = async (userId: string | number) => {
    try {
      const { data } = await $api.get<TTotalAppVolumeResponse>(
        `api/admins/token-total-volume?id=${userId}`,
      );

      return data;
    } catch (error) {
      console.error('Error fetching user app volume:', error);
    }
  };

  return { getTokenByPurchase, getTokenAppVolume };
};

export const tokenService = TokenService();
